module.exports = __webpack_public_path__ + "static/media/enfase-2.b1e326c8.jpg";